import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase/app';
import Constants from '../commons/Constants';
import firebaseConfig from '../firebaseConfig.js';
import firebaseConfigDev from '../firebaseConfig.dev.js';

console.log('==> FRONTEND ENV ',process.env.NODE_ENV);

Vue.use(Vuex);
if(process.env.NODE_ENV === 'production'){
	firebase.initializeApp(firebaseConfig);
}else{
	firebase.initializeApp(firebaseConfig);
}

export const userStore = new Vuex.Store({
	state: {
		permissions: [],
		company: '',
		openingOrder: false,
		companyphoto: '',
		userName: '',
		userId: '',
		role: '',
		user: {}
	},
	mutations: {
		setUser(state, user) {
			state.user = user;
		},
		setUserName(state, name) {
			state.userName = name;
		},
		setUserCompany(state, company) {
			state.company = company;
		},
		setUserPermissions(state, permissions) {
			state.permissions = permissions;
		},
		openOrder(state) {
			state.openingOrder = true;
		},
		closeOrder(state) {
			state.openingOrder = false;
		},
		setCompanyPhoto(state, photo) {
			state.companyphoto = photo;
		},
		setUserId(state, id) {
			state.userId = id;
		},
		setRole(state, role){
			state.role = role;
		}
	},
	actions: {},
	getters: {
		user(state) {
			return state.user;
		},
		userName(state) {
			return state.userName;
		},
		getCompany(state) {
			return state.company;
		},
		getUserPermissions(state) {
			return state.permissions;
		},
		isAdmin(state) {
			return state.role === Constants.userRoles.ADMIN;
		},
		isComerce(state) {
			return state.role === Constants.userRoles.COMERCE;
		},
		isDelivery(state) {
			return state.role === Constants.userRoles.DELIVERY;
		},
		getCompanyPhoto(state) {
			return state.companyphoto;
		},
		getUserId(state){
			return state.userId;
		},
		getRole(state){
			return state.role;
		}
	}
});
